import axios from "axios";
import { LoginService } from "./loginService";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔐 Attach access token to every request
apiClient.interceptors.request.use((config) => {
  const token = LoginService.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// 🔁 Automatically refresh token if expired
apiClient.interceptors.response.use(
  (response) => response,
  async (error: any) => {
   const originalRequest = error.config as any & { _retry?: boolean };

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const newTokens = await LoginService.refreshToken();
      if (newTokens?.token) {
        localStorage.setItem("token", newTokens.token);
        localStorage.setItem("refreshToken", newTokens.refreshToken);

        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `Bearer ${newTokens.token}`,
        };

        return apiClient(originalRequest);
      } else {
        await LoginService.logout();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
